<div class="indicator">
  <div class="circle" *ngIf="isComparison()">
    <svg class="stat-progress">
      <circle class="progress-meter" cx="15" cy="15" r="12"/>
      <circle class="progress-value" #progressValue cx="15" cy="15" r="12"/>

      <svg class="circular-chart inside" *ngIf="showOverPerformCircle">
        <circle class="over-perform" #overPerformValue cx="15" cy="15" r="9"/>
      </svg>
    </svg>
    <svg-icon class="arrow-up-agent-stat-icon" icon="arrow-up-agent-stat" [ngClass]="{ 'only-one-arrow-displayed': !shouldShowBothProgressArrows, 'positive-action': isPositiveActionTriggered }"></svg-icon>
    <svg-icon class="arrow-down-agent-stat-icon" icon="arrow-up-agent-stat" *ngIf="shouldShowBothProgressArrows"></svg-icon>
  </div>
  <div class="indicator-details">
    <div class="title">{{ indicatorShortName | translate }}</div>
    <div class="value" #val>
      <ng-container *ngIf="isComparison()">
        <span class="current-value" #valNum>{{ getPerformancePercentage() }}</span>
        <span class="value-type" #valType>{{ indicatorPostFix  | translate }}</span>
      </ng-container>
      <ng-container *ngIf="!isComparison()">
        <span class="current-value" #valNum>{{ getCurrentValue() }}</span>
      </ng-container>
    </div>
  </div>
</div>
